import React from "react";

import "css/main.css";
import "css/style.css";

/* DocumentList is a pair of: {documentId: Int, documentName: String} */
function FileDownload({ documentList=[] }) {
  return (
    <div className="anexos">
      <ul>
        {documentList.map((el, idx) => (
					el?.attributes?.body?.data?.attributes?.url &&
          <a key={idx} rel="noreferrer" href={el.attributes.body.data.attributes.url} target="_blank">
					<li style={{"textDecorationLine": "underline","cursor": "pointer"}} >
              <span className="icon">
                <i className="fa fa-paperclip"></i>
              </span>
              {el.attributes.name}
          </li>
					</a>
					)
				)}
      </ul>
    </div>
  );
}

export default FileDownload;

